import type { AppMode } from '@iheartjane/types';

import { selectEmbeddedApp } from '@jane/monolith/customer/redux/embeddedApp';
import { selectStore } from '@jane/monolith/customer/redux/store';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
// eslint-disable-next-line no-restricted-imports
import type { NoStore, Store } from '@jane/shared/models';
import { useEcommApp } from '@jane/shared/providers';
import { isStore } from '@jane/shared/util';

export const isGuestCheckoutEnabled = ({
  store,
  appMode,
  disableAuthFeatures,
}: {
  appMode: AppMode;
  disableAuthFeatures: boolean;
  store?: Store | NoStore;
}) =>
  Boolean(
    appMode === 'headless' ||
    disableAuthFeatures ||
    !isStore(store) ||
    !store.guest_checkout_setting?.disabled
  );

export const useGuestCheckoutEnabled = () => {
  const { store } = useCustomerSelector(selectStore);
  const { appMode } = useEcommApp();
  const { disableAuthFeatures } = useCustomerSelector(selectEmbeddedApp);

  return isGuestCheckoutEnabled({
    store,
    appMode,
    disableAuthFeatures,
  });
};
